const openWindow = (url) => window.open(url, "_blank");

export default openWindow;
